import ProductPreviewUiState from '@features/productPreview/mobX/state/ProductPreviewUiState';
import ProductPreviewPageState from '@features/productPreview/mobX/state/ProductPreviewPageState';
import layoutUiState from '@features/layout/mobX/LayoutUiState';
export const uiState = new ProductPreviewUiState(layoutUiState);
export const productPageState = new ProductPreviewPageState();